import Splide from "@splidejs/splide";
import "@splidejs/splide/css";
// import Plyr from 'plyr'

document.addEventListener("DOMContentLoaded", function () {
  // const splide_settings = JSON.parse(wtm_product_vars.gallery_settings)
  const main_slider = document.querySelector("#main-slider");
  const thumbnail_slider = document.querySelector("#thumbnail-slider");
  const custom_pause_event = new Event("handle_pause_on_change", { bubbles: true });
  const custom_play_event = new Event("handle_play_on_demand", { bubbles: true });
  const customEvent = new Event("product-slider");

  var main = new Splide(main_slider, {
    type: "fade",
    // rewind: true,
    fixedHeight: 550,
    fixedWidth: 550,
    // pagination: splide_settings.bullets,
    arrows: false,
    pagination: false,
    loop: true,
    // drag: main_slider.querySelector('video') ? false : true,
    // autoplay: splide_settings.autoplay,
    // interval: (splide_settings.delay != '' && splide_settings.autoplay) ? splide_settings.delay : 2000,
    breakpoints: {
      768: {
        fixedHeight: false,
      },
      1366: {
        fixedHeight: 450,
        fixedWidth: 450,
      },
      992: {
        fixedWidth: false,
        fixedHeight: 450,
      },
      576: {
        fixedWidth: false,
        fixedHeight: 300,
      },
    },
  });

  let thumbnails = new Splide(thumbnail_slider, {
    fixedWidth: 125,
    fixedHeight: 125,
    perPage: 4,
    gap: 17,
    rewind: true,
    pagination: false,
    cover: true,
    isNavigation: true,
    arrows: false,
    breakpoints: {
      600: {
        fixedWidth: 75,
        fixedHeight: 75,
        perPage: 4,
        gap: 5,
      },
    },
  });

  main.sync(thumbnails);
  main.mount();
  thumbnails.mount();

  main.on("move", () => {
    document.dispatchEvent(customEvent);
  });

  jQuery(".single_variation_wrap").on("show_variation", function (event, variation) {
    const target = document.querySelector(`#main-slider [data-variation='${variation.variation_id}']`);

    if (target != null && target != "undefinded") {
      main.go(parseInt(target.dataset.slide));
    }

    document.querySelector(".add_to_cart_button").dataset.variation = variation.variation_id;
  });
  if (document.querySelector("button.product_type_variation")) {
    document.querySelector("button.product_type_variation").addEventListener("click", (e) => {
      document.querySelector("button.product_type_variation").classList.add("loading");
    });
  }
});
